<template>
  <div class="goods_detail">
    <el-card class="box-card" type="card">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="货补上账" name="up">
          <DetailTable
            :tableData="tableData"
            :page="page"
            :total="total"
            :loading="loading"
            :hiddenPage="hiddenPage"
            functionCode="fee_rep_detail_on_account_export"
            parentCode="CRM20210127000000843"
            requestUrl="/fee/hdFeePoolGoodsController/findFeePoolDetailAccountList"
            type="up"
            tabType="goodsDetail"
            @dateTimeChange="timeChangeSearch"
            @timeReset="timeReset"
            @pageChange="pageChange"
            @sizeChange="sizeChange"
          >
          </DetailTable>
        </el-tab-pane>
        <el-tab-pane disabled label="|"></el-tab-pane>
        <el-tab-pane label="货补使用" name="use">
          <DetailTable
            :loading="loading"
            :tableData="tableData"
            type="use"
            tabType="goodsDetail"
            :page="page"
            :hiddenPage="hiddenPage"
            :total="total"
            functionCode="fee_rep_detail_use_export"
            parentCode="CRM20210127000000843" 
            requestUrl="/fee/hdFeePoolGoodsController/findFeePoolUseList"
            @dateTimeChange="timeChangeSearch"
            @timeReset="timeReset"
            @pageChange="pageChange"
            @sizeChange="sizeChange"
          >
          </DetailTable>
        </el-tab-pane>
      </el-tabs>
    </el-card>
  </div>
</template>

<script>
/**
 * @description: 接口 
 * @param {*} goodsUpDetail 费用上账  
 * @param {*} goodsUseDetail 费用使用
 * @param {*} DetailTable 表格组件
 * @return {*}
 * @author: txp
 */
import { goodsUpDetail, goodsUseDetail } from "@/api/api";
import { Storage } from "@/utils/storage";
import DetailTable from "./components/DetailTable";
export default {
  name: "GoodsDetail",
  components: { DetailTable },
  data() {
    return {
      activeName: "up", //标签页切换参数
      hiddenPage:false,//页数为1时是否隐藏分页
      page: {
        pageSize: 10, //每页展示的条数
        pageNum: 1, //第几页
      },
      tableData: [],
      total: 0, //数据总条数
      loading:true
    };
  },
   watch:{
    /**
     * @description 监听total数值的变化 无数据时隐藏 分页
     */
    total(newVal,oldVal){
        newVal== 0 ? (this.hiddenPage = true):(this.hiddenPage = false)
    }
  },
  created(){
    this.getGoodsUpDetail(this.getInfo());
  },
  mounted(){},
  methods: {
    /**
     * @description 接口请求参数封装函数
     * @param { String }    customerCode 用户编码
     * @param { Object }    page         分页参数
     */
    getInfo() {
      let customerCode = Storage.l.get("customerCode");
      return {
        customerCode: customerCode,
         ...this.page,
      };
    },
    /**
     * @description 公共Switch函数封装
     * @param { String }    condition   switch 判断条件参数
     * @param { Object }    params      接口请求参数
     */
    switchCommonFunction(condition,params){
      switch (condition) {
        case "up":
          this.getGoodsUpDetail(params);
          break;
        case "use":
          this.getGoodsUseDetail(params);
          break;
      }
    },
    /**
     * @description  货补 上账接口请求函数
     * @param { Number }    total      数据条数
     * @param { Array }     tableData  表格展示数数组
     */
    getGoodsUpDetail(params) {
       this.loading = true
      goodsUpDetail(params).then((res) => {
        this.total = res.result.count;
        this.tableData = res.result.data;
        this.loading = false
      });
    },
    /**
     * @description  折扣 使用接口请求函数
     */
    getGoodsUseDetail(params) {
      this.loading = true
      goodsUseDetail(params).then((res) => {
        this.total = res.result.count;
        this.tableData = res.result.data;
        this.loading = false
      });
    },
    /**
     * @description  分页标签点击函数
     * @param tab               见element-ui
     * @param event             见element-ui
     * @param { Number }  index tabs点击项的索引
     */
    handleClick(tab, event) {
      this.activeName = tab.name
      this.page.pageNum = 1
      this.switchCommonFunction(this.activeName,this.getInfo())
    },
    /**
     * @description 组件折扣上账日期选择监听查询
     */
    timeChangeSearch(type,timeData) {
      let params = {
        ...timeData,
        ...this.getInfo(),
      };
      this.switchCommonFunction(type,params)
    },
    /**
     * @description 组件折扣上账日期重置函数
     */
    timeReset(type) {
      this.page.pageNum = 1;
      this.switchCommonFunction(type,this.getInfo())
    },
    /**********************页码组件函数***********************/
    /**
     * @description 页码变化监听函数
     * @param { String }   up      折扣类型--上账
     * @param { String }   use     折扣类型--使用
     * @param { Number }   pageNum 页码
     */
    pageChange(type,pageNum){
      this.page.pageNum = pageNum;
      this.switchCommonFunction(type,this.getInfo())
    },
    /**
     * @description 页条数变化监听函数
     * @param { String }   up       折扣类型--上账
     * @param { String }   use      折扣类型--使用
     * @param { Number }   pageSize 每一页显示的数量
     */
    sizeChange(type,pageSize){
      this.page.pageSize = pageSize;
      this.switchCommonFunction(type,this.getInfo())
    }
  },
};
</script>

<style lang="scss" scoped>
.goods_detail {
  height: 100%;
  /deep/ .el-card{
    height: 100%;
      .el-tabs__item{
          font-size: 18px;
          margin-bottom: 7px;
          padding: 0px 10px;
      }
      .el-tabs__active-bar{
        width: 78px!important;
      }
  }
}
</style>